/**
 * A credit bundle is a gem pack of the v2 shop (the web's gem shop and the iOS
 * app's store both read them, through the engine's GET /api/library/gem-packs).
 * One row per pack, the same for every client. The server's strict model is
 * immersive-server's dto/credit-bundles.dto.ts; these rules mirror it so a bad
 * value is caught before the save.
 */
export type GemPackFormValues = {
  /** Sent on create only: an edit never sends it (editableOf). */
  key?: string;
  name: string;
  creditsAmount: number;
  bonusCredits: number;
  priceUsd: number;
  isBest: boolean;
  isActive: boolean;
  sortOrder: number;
  appleProductId: string;
  googleProductId: string;
};

export const gemPackDefaults: GemPackFormValues = {
  key: "",
  name: "",
  creditsAmount: 100,
  bonusCredits: 0,
  priceUsd: 0.99,
  isBest: false,
  isActive: true,
  sortOrder: 0,
  appleProductId: "",
  googleProductId: "",
};

/** The fields an edit may change, and nothing else: the server's model is strict, and a pack's key is set once. */
export const editableOf = (v: GemPackFormValues) => ({
  name: v.name,
  creditsAmount: v.creditsAmount,
  bonusCredits: v.bonusCredits,
  priceUsd: v.priceUsd,
  isBest: v.isBest,
  isActive: v.isActive,
  sortOrder: v.sortOrder,
  appleProductId: v.appleProductId ?? "",
  googleProductId: v.googleProductId ?? "",
});

/** What the shop shows for a pack: its gems (credits + bonus) and the bonus as a percent of the credits. */
export const gemsOf = (credits: number, bonus: number) => ({
  gems: (Number(credits) || 0) + (Number(bonus) || 0),
  percent: Number(credits) > 0 ? Math.round(((Number(bonus) || 0) * 100) / Number(credits)) : 0,
});
